import React, {useMemo} from "react";
import {PageHeading} from "peggirkit";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import {useIntl} from "react-intl";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import DashboardLinks from "@widgets/dashboard/links/DashboardLinks";
import {reportsMenuSection} from "@widgets/layout/menu/MenuItems";


const Reports = () => {
    const intl = useIntl();
    const route: Route = useMemo(() => router.reports, [])

    return (
        <AdminLayout currentPage={route}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={route.name(intl)}
            />

            <DashboardLinks menuSections={[reportsMenuSection]}/>
        </AdminLayout>
    );
};

export default Reports;